import { useParams } from 'react-router-dom';
import pfp from '../../img/pfp.jpg'

function AboutSection() {
  const { local } = useParams();
  return (
    <section
      className="px-6 py-16 mx-auto max-w-6xl text-lg leading-relaxed text-[#f5f1ea]"
      id="o-mnie"
      style={{ backgroundColor: 'rgba(28,20,16,0.8)', borderRadius: '1rem' }}
    >
      <p className="header mb-10 text-center text-[#c6a15b]">
        O mnie
      </p>

      <div className="flex flex-col md:flex-row items-center md:items-start gap-10">
        {/* Zdjęcie klimatyczne */}
        <div className="flex-shrink-0 md:w-1/2">
          <img
            src={pfp}
            alt="Saunamistrz Maciej Głąb podczas ceremonii saunowej"
            className="w-full h-auto rounded-2xl object-cover shadow-2xl"
            loading="lazy"
          />
        </div>

        {/* Tekst */}
        <article className="md:w-1/2" itemScope itemType="https://schema.org/Person">
  <meta itemProp="jobTitle" content="Saunamistrz / Opiekun Saun" />
  <meta itemProp="name" content="Maciej Głąb" />

  {/* <p className="mb-6" itemProp="description">
    Nazywam się <strong>Maciej Głąb</strong>, jestem członkiem <strong>Polskiego Stowarzyszenia Saunowego</strong> i prowadzę profesjonalne 
    <strong> ceremonie saunowe</strong> dla obiektów, które chcą wyróżnić się 
    jakością i wyjątkowym doświadczeniem gościa. Tworzę seanse, które budują klimat, przyciągają klientów i zachęcają do powrotów.
  </p> */}

  <p className="mb-6">
    Każda ceremonia to świadoma praca z ciepłem, rytmem i 
    <strong> starannie dobranymi zapachami</strong> od świeżych nut 
    oczyszczających po głębokie, otulające kompozycje budujące atmosferę relaksu.
  </p>

  <p className="mb-6">
    Miłuję się w <strong>muzyce rockowej i metalowej</strong>, dlatego w moich seansach czuć energię i charakter. 
    Jednocześnie potrafię dopasować oprawę muzyczną do każdego odbiorcy i profilu obiektu.
  </p>

  <p>
    Jeśli chcesz wprowadzić do swojego obiektu ceremonie, które podnoszą prestiż i zapadają w pamięć,{" "}
    <a href={`/${local}/kontakt`} className="font-semibold underline decoration-2 text-[#c6a15b]">
      skontaktuj się ze mną
    </a>.
  </p>
</article>

      </div>
    </section>
  );
}

export default AboutSection;
